"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.payment.confirmed': '支付确认',
    'route.payment.list': '付款记录',
    'route.payment.preview': '付款详情',
};
